<template>
    <div class="animated fade-in">
        <c-data-table
            ref="notification-message-table"
            class="my-4"
            :items="items" 
            :fields="fields"  
            :table-filter="true"
            :items-per-page="params.limit"
            items-per-page-select 
            hover 
            sorter
            :pagination="false"
            :sorterValue="params.sort"
            :tableFilterValue="params.filter"
            :loading="loading"
            @pagination-change="pageChange"
            @update:sorter-value="sortChange"
            @update:table-filter-value="filterChange">
            <template #type="{item}">
                <td>
                    <span v-if="item.type">{{ item.type.split('\\').pop() }}</span>
                    <span v-if="!item.type">Global</span>
                </td>
            </template>
            <template #model="{item}">
                <td>
                    <div v-if="item.model_type">
                        {{item.model_type}}
                    </div>
                    <div v-if="!item.model_type">N/A</div>
                </td>
            </template>
            <template #filter_value="{item}">
                <td>
                    <div v-if="item.filter_value">
                       {{item.filter_value}}
                    </div>
                    <div v-if="!item.filter_value">N/A</div>
                </td>
            </template>
            <template #message="{item}">
                <td>
                    <span v-if="item.message">{{ item.message.substring(0, 50) }}...</span>
                </td>
            </template>
            <template #created_at="{item}">
                <td>
                    <span v-if="item.created_at">{{ item.created_at | moment("MMM D, YYYY, h:mm:ss a") }}</span>
                </td>
            </template>
            <template #actions="{item}">
                <td>
                    <b-button-group>
                        <b-button size="sm" variant="outline-dark" squared v-b-tooltip.hover title="View" @click="viewNotificationMessage(item)"><font-awesome-icon :icon="['fal','eye']"></font-awesome-icon></b-button>
                        <b-button size="sm" variant="outline-dark" squared v-b-tooltip.hover title="Edit" @click="editNotificationMessage(item)"><font-awesome-icon :icon="['fal','pencil']"></font-awesome-icon></b-button>
                        <b-button size="sm" variant="outline-dark" squared v-b-tooltip.hover title="Delete" @click="deleteNotificationMessage(item)"><font-awesome-icon :icon="['fal','trash']"></font-awesome-icon></b-button>
                    </b-button-group>
                </td>
            </template>
        </c-data-table>
        <c-pagination
            :active-page="params.page"
            :pages="+(total/params.limit)"
            @update:activePage="updatePageNum"
        ></c-pagination>
        <c-modal scrollable :show.sync="show_preview" title="View Notification Message" size="lg">
            <p class="pre-wrap">{{ preview_message }}</p>
            <template #footer=""><span></span></template>
        </c-modal>
        <c-modal v-if="current_message" scrollable :show.sync="show_edit" :title="'Edit ' + (current_message && current_message.type ? current_message.type.split('\\').pop() : 'Global') + ' Message'" size="lg">
            <b-select class="mb-2" v-if="isOrderType" v-model="current_message.filter_value" :options="orderFilters"></b-select>
            <b-textarea v-model="current_message.message" placeholder="Message" style="height: 300px"></b-textarea>
            <template #footer="">
                <b-button-group class="float-left mr-2">
                    <b-button variant="outline-success" squared @click="saveMessage"><font-awesome-icon :icon="['fal','save']"></font-awesome-icon></b-button>
                </b-button-group>
            </template>
        </c-modal>
    </div>
</template>

<script>
  import NotificationMessage from "../../models/NotificationMessage";
  import ToastNotifications from "../shared/mixins/ToastNotifications";

  export default {
      name: 'NotificationMessageTable',
      mixins: [ToastNotifications],
      props: ['refresh'],
      data () {
        return {
          loading: true,
          notification_messages: [],
          items: [],
          fields: [
            { key: 'type', label: 'Type' },
            { key: 'model', label: 'Reference' },
            { key: 'filter_value', label: 'Filter' },
            { key: 'message', label: 'Message' },
            { key: 'created_at', label: 'Created At' },
            { key: 'actions', label: 'Actions' },
          ],
          total: null,
          params: {
            page: 1,
            limit: 20,
            sort: { column: 'created_at', asc : false},
            filter: null
          },
          show_preview: false,
          preview_message: null,
          show_edit: false,
          current_message: null,
        }
      },
      computed: {
        isOrderType() {
          return this.current_message && this.current_message.type === NotificationMessage.orderStatusChanged;
        },
        orderFilters() {
          return [{value: null, text: '-- Assign a status --'}].concat(NotificationMessage.orderStatusFilters.map(filter => ({value: filter, text: filter})));
        }
      },
	  methods: {
        pageChange: function(val) {
          this.params.limit = val;
          this.fetchNotificationMessages();
        },
        sortChange: function(val) {
          this.params.sort.column = val.column;
          this.params.sort.asc = val.asc;
          this.fetchNotificationMessages();
        },
        filterChange: function(val) {
          this.params.filter = (val ? (val != '' ? val : null) : null);
          this.fetchNotificationMessages();
        },
        updatePageNum: function(val) {
          this.params.page = val;
          this.fetchNotificationMessages();
        },
        fetchNotificationMessages: function() {
          this.loading = true;
          let params = JSON.parse(JSON.stringify(this.params));
          NotificationMessage.api().fetch(params).then((results) => {
            this.total = results.response.data.data.pagination.total;
            this.notification_messages = results.entities.notification_messages;
            this.items = this.notification_messages;
            this.loading = false;
          });
        },
        viewNotificationMessage(message) {
          this.show_preview = true;
          this.preview_message = message.message;
        },
        deleteNotificationMessage(message) {
          NotificationMessage.api().remove(message.id);
          this.quickSuccessToast('Notification message was deleted.', 'The message will no longer be sent with notifications.');
          this.fetchNotificationMessages();
        },
        editNotificationMessage(message) {
          this.show_edit = true;
          this.current_message = message;
        },
        saveMessage() {
          let payload = JSON.parse(JSON.stringify(this.current_message));
          let {$id, id,created_at,deleted_at,updated_at, ...filtered} = payload;
          NotificationMessage.api().update(id, filtered).then(() => {
            this.quickSuccessToast('Notification message was updated.', 'The new message will show up on upcoming notifications.');
            this.fetchNotificationMessages();
            this.current_message = null;
            this.show_edit = false;
          });
        }
      },
      watch: {
        refresh: function() {
          if(this.refresh) {
            this.$emit('onRefresh');
            this.fetchNotificationMessages();
            this.$emit('onRefreshed');
          }
        },
      },
      created() {
        this.fetchNotificationMessages();
      }
	}
</script>
<style>
    .pre-wrap {
        white-space: pre-line;
    }
</style>
